import {mapGetters} from 'vuex'

export var geolocationMixin = {
  data() {
    return {
      gpsDialog: false,
      // HLConfirm props of the GPS dialog currently shown
      gpsDialogOptions: {}
    }
  },
  computed: {
    ...mapGetters('geolocation', ['gpsStatus', 'isGpsDenied', 'hasGpsProblem', 'position', 'coarseDialogPending']),
  },
  methods: {
    showGpsDialog(options) {
      this.gpsDialogOptions = options;
      this.gpsDialog = true;
    },
    // permission denied or no fix yet, picked by the current status
    showGpsProblemDialog() {
      const denied = this.isGpsDenied;
      this.showGpsDialog({
        title: this.$t(denied ? 'permissionDenied' : 'gpsNoSignal'),
        text: this.$t(denied ? 'gpsPermissionDeniedMsg' : 'gpsNoSignalMsg'),
        icon: denied ? 'mdi-crosshairs-off' : 'mdi-crosshairs-question'
      });
    },
    // accuracy stayed coarse: probably only the approximate location was granted (HLConfirm renders the text as HTML)
    showGpsCoarseDialog() {
      this.showGpsDialog({
        title: this.$t('gpsCoarse'),
        text: this.$t('gpsCoarseMsg') + '<br><small>' + this.$t('gpsCoarseHint') + '</small>',
        icon: 'mdi-map-marker-radius'
      });
    },
    // position known, but the spot's checkin radius (scr) is not reached
    showNotInRangeDialog(spot) {
      this.showGpsDialog({
        title: this.$t('taskNotInRange'),
        text: this.$t('taskNotInRangeMsg', {distance: spot.scr}),
        icon: 'mdi-map-marker-distance'
      });
    },
    requestPosition() {
      return this.$store.dispatch('geolocation/requestPosition');
    }
  }
}
